import { render, staticRenderFns } from "./LicenceDetails.vue?vue&type=template&id=da36abec&scoped=true&%3Akey=componentKey&"
import script from "./LicenceDetails.vue?vue&type=script&lang=ts&"
export * from "./LicenceDetails.vue?vue&type=script&lang=ts&"
import style0 from "./LicenceDetails.vue?vue&type=style&index=0&id=da36abec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da36abec",
  null
  
)

export default component.exports